<!--NOTE: data setup user actions double click prevents full screen to open-->
<video
  #videoPlayer
  [attr.playsinline]="playsinline"
  class="video-js"
  data-setup='{"userActions": {"doubleClick": false }}'></video>
